import { useApiStore } from '@/stores/apiStore';
import { UserStatusApi } from '@/../generated-client/apis/UserStatusApi';
import { LocationQueryByTimeRequest } from '../../generated-client/models';

let userStatusApi: UserStatusApi | null = null;
let lastConfig: unknown = null;

function getUserStatusApi(): UserStatusApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (userStatusApi === null || lastConfig !== apiConfig) {
    userStatusApi = new UserStatusApi(apiConfig);
    lastConfig = apiConfig;
  }

  return userStatusApi;
}
export const getLocationsBetweenTimestamps = async (
  requestPayload: LocationQueryByTimeRequest,
) => {
  const api = getUserStatusApi();

  return await api.apiUserStatusUserLocationsTimerangePost({
    locationQueryByTimeRequest: requestPayload,
  });
};
